import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { useDocumentTitle } from '@/hooks/document-title'
import { useActivation } from '@/hooks/view-model-hooks'
import { useScrollOffsets } from '@/hooks/element-hooks'
import { isRefreshDesign } from '@/infra/design'
import { ClientUserManagement } from '@/features/client-user-management/ClientUserManagement'
import { ClientUserManagementTableContainer } from '@/features/client-user-management/components/ClientUserManagementTable/ClientUserManagementTableContainer'
import { ClientListContainer } from '@/features/client-user-management/components/ClientListContainer'
import { ClientInvitationDialogContainer } from '@/features/client-user-management/ClientInvitationDialog/ClientInvitationDialogContainer'

export default observer(function ClientUserManagementContainer() {
  const { clientUserManagement, shellInfo } = useFeatures((r) => ({
    clientUserManagement: r.clientUserManagement.internal(),
    shellInfo: r.shell.shellInfo,
  }))
  const vm = clientUserManagement.clientUserManagementViewModel
  useDocumentTitle('User Management')
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()
  useActivation(vm)

  return (
    <ClientUserManagement
      canAccessClientUserManagement={vm.canAccessClientUserManagement}
      scrollRef={scrollRef}
      scrollOffset={scrollOffset}
      canInviteClients={vm.canInviteClients}
      corporateMode={shellInfo.corporateMode}
      onInvite={vm.clientInvitationVm.show}
    >
      {isRefreshDesign ? (
        <ClientListContainer vm={vm} />
      ) : (
        <ClientUserManagementTableContainer vm={vm} />
      )}
      <ClientInvitationDialogContainer vm={vm.clientInvitationVm} />
    </ClientUserManagement>
  )
})
